export const INCIDENT_UPLOAD_MAX_SIZE = 1024 * 1024 * 25;
export const INCIDENT_UPLOAD_MAX_FILES = 20;
